// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xt-1";
export var printerIcon = "_xt-0";